
import { States } from "../proto/states";

const SpouseInvestmentAcct = {
  COMMUNITY_PROPERTY: "COMMUNITY_PROPERTY",
  TENANTS_BY_ENTIRETY: "TENANTS_BY_ENTIRETY",
  TENANTS_IN_COMMON: "TENANTS_IN_COMMON",
  JTWROS: "JOINT_TENNANTS_WITH_RIGHTS_OF_SURVIVORSHIP",
}

const COMMUNITY_PROPERTY_STATES = [
  States.AZ.id,
  States.CA.id,
  States.ID.id,
  States.LA.id,
  States.NV.id,
  States.NM.id,
  States.PR.id,
  States.TX.id,
  States.WA.id,
  States.WI.id,
];

const TENNANTS_BY_ENTIRETY_STATES = [
  States.AK.id,
  States.AR.id,
  States.DE.id,
  States.DC.id,
  States.FL.id,
  States.HI.id,
  States.KY.id,
  States.MD.id,
  States.MA.id,
  States.MI.id,
  States.MS.id,
  States.MO.id,
  States.NJ.id,
  States.OK.id,
  States.PA.id,
  States.RI.id,
  States.TN.id,
  States.VT.id,
  States.VA.id,
  States.WY.id,
]

// States not in Joint Tennans With Rights of Survivorship
const STATES_NOT_IN_JTWROS = [
  States.LA.id,
];

const StateToSpouseInvestmentAcct = {
  AL: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  AK: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  AZ: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  AR: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  CA: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  CO: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  CT: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  DE: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  DC: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  FL: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  GA: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  HI: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  ID: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  IL: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  IN: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  IA: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  KS: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  KY: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  LA: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  ME: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  MD: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  MA: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  MI: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  MN: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  MS: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  MO: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  MT: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  NE: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  NV: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  NH: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  NJ: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  NM: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  NY: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  NC: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  ND: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  OH: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  OK: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  OR: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  PA: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  PR: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  RI: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  SC: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  SD: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  TN: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  TX: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  UT: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  VT: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  VA: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
  WA: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  WV: SpouseInvestmentAcct.TENANTS_IN_COMMON,
  WI: SpouseInvestmentAcct.COMMUNITY_PROPERTY,
  WY: SpouseInvestmentAcct.TENANTS_BY_ENTIRETY,
}

const STATE_TO_JOINT_ACCT_TYPE = state => {
  return {
    [SpouseInvestmentAcct.COMMUNITY_PROPERTY]: COMMUNITY_PROPERTY_STATES.includes(state),
    [SpouseInvestmentAcct.TENANTS_BY_ENTIRETY]: TENNANTS_BY_ENTIRETY_STATES.includes(state),
    [SpouseInvestmentAcct.JTWROS]: !STATES_NOT_IN_JTWROS.includes(state),
    [SpouseInvestmentAcct.TENANTS_IN_COMMON]: true,
  }
}

const ACCT_TYPE_TO_DOCUSIGN = acct_type => {
  if (acct_type === SpouseInvestmentAcct.COMMUNITY_PROPERTY) {
    return "CommunityProperty";
  } else if (acct_type === SpouseInvestmentAcct.TENANTS_BY_ENTIRETY) {
    return "TenantsByTheEntireties";
  } else if (acct_type === SpouseInvestmentAcct.TENANTS_IN_COMMON) {
    return "TenantsInCommon";
  } else if (acct_type === SpouseInvestmentAcct.JTWROS) {
    return "JointTenants";
  }
  throw new Error("Can't convert", acct_type);
}

export { SpouseInvestmentAcct, StateToSpouseInvestmentAcct, STATE_TO_JOINT_ACCT_TYPE,
  ACCT_TYPE_TO_DOCUSIGN };
